// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edm-gio-wrapper {
  height: 100vh;
  font-family: "Nunito";
}
.edm-gio-wrapper .em_full_wrap {
  background-color: #f7f7f7;
}
.edm-gio-wrapper {
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
}
.edm-gio-wrapper img {
  border: 0;
  outline: none;
}
.edm-gio-wrapper p {
  margin: 0px;
  padding: 0px;
}
.edm-gio-wrapper table {
  border-collapse: collapse;
  mso-table-lspace: 0px;
  mso-table-rspace: 0px;
}
.edm-gio-wrapper td,
.edm-gio-wrapper a,
.edm-gio-wrapper span {
  border-collapse: collapse;
  mso-line-height-rule: exactly;
}
.edm-gio-wrapper a[x-apple-data-detectors] {
  color: inherit;
  text-decoration: none;
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  line-height: inherit;
}
.edm-gio-wrapper .ExternalClass * {
  line-height: 100%;
}
.edm-gio-wrapper em_hide .em_defaultlink a {
  color: inherit;
  text-decoration: none;
}
.edm-gio-wrapper .em_g_img + div {
  display: none;
}
.edm-gio-wrapper .em_wrapper,
.edm-gio-wrapper .em_hide {
  background-color: #ffffff;
}

@media only screen and (max-width: 640px) {
  .edm-gio-wrapper .em_img {
    width: 100% !important;
    height: auto !important;
  }
  .edm-gio-wrapper .em_main_table {
    width: 100% !important;
  }
  .edm-gio-wrapper .em_wrapper {
    width: 100% !important;
  }
  .edm-gio-wrapper .em_wrapper1 {
    width: 100% !important;
    display: block !important;
  }
  .edm-gio-wrapper .em_wrapper2 {
    width: 60% !important;
  }
  .edm-gio-wrapper .em_wrapper3 {
    width: 40% !important;
  }
  .edm-gio-wrapper .em_height {
    height: auto !important;
  }
  .edm-gio-wrapper .em_hide {
    display: none !important;
  }
  .edm-gio-wrapper .em_padding20 {
    padding-top: 20px !important;
  }
  .edm-gio-wrapper .em_padding {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .edm-gio-wrapper .em_font22 {
    font-size: 22px !important;
    line-height: 28px !important;
  }
  .edm-gio-wrapper .em_font {
    font-size: 10px !important;
    line-height: 14px !important;
  }
  .edm-gio-wrapper u + .em_body .em_full_wrap {
    width: 100% !important;
    width: 100vw !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/custom-redeem/edm/gio/EdmGio.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qBAAA;AACF;AAAE;EACE,yBAAA;AAEJ;AANA;EAME,SAAA;EACA,UAAA;EACA,8BAAA;EACA,0BAAA;EACA,mCAAA;AAGF;AADE;EACE,SAAA;EACA,aAAA;AAGJ;AADE;EACE,WAAA;EACA,YAAA;AAGJ;AADE;EACE,yBAAA;EACA,qBAAA;EACA,qBAAA;AAGJ;AADE;;;EAGE,yBAAA;EACA,6BAAA;AAGJ;AADE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;AAGJ;AAAE;EACE,iBAAA;AAEJ;AAAE;EACE,cAAA;EACA,qBAAA;AAEJ;AAAE;EACE,aAAA;AAEJ;AACE;;EAEE,yBAAA;AACJ;;AAGA;EAEI;IACE,sBAAA;IACA,uBAAA;EADJ;EAGE;IACE,sBAAA;EADJ;EAGE;IACE,sBAAA;EADJ;EAGE;IACE,sBAAA;IACA,yBAAA;EADJ;EAGE;IACE,qBAAA;EADJ;EAGE;IACE,qBAAA;EADJ;EAGE;IACE,uBAAA;EADJ;EAGE;IACE,wBAAA;EADJ;EAGE;IACE,4BAAA;EADJ;EAGE;IACE,6BAAA;IACA,8BAAA;EADJ;EAGE;IACE,0BAAA;IACA,4BAAA;EADJ;EAGE;IACE,0BAAA;IACA,4BAAA;EADJ;EAGE;IACE,sBAAA;IACA,uBAAA;EADJ;AACF","sourcesContent":[".edm-gio-wrapper {\n  height: 100vh;\n  font-family: \"Nunito\";\n  .em_full_wrap {\n    background-color: #f7f7f7;\n  }\n  margin: 0;\n  padding: 0;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -webkit-font-smoothing: antialiased;\n\n  img {\n    border: 0;\n    outline: none;\n  }\n  p {\n    margin: 0px;\n    padding: 0px;\n  }\n  table {\n    border-collapse: collapse;\n    mso-table-lspace: 0px;\n    mso-table-rspace: 0px;\n  }\n  td,\n  a,\n  span {\n    border-collapse: collapse;\n    mso-line-height-rule: exactly;\n  }\n  a[x-apple-data-detectors] {\n    color: inherit;\n    text-decoration: none;\n    font-size: inherit;\n    font-family: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n  }\n\n  .ExternalClass * {\n    line-height: 100%;\n  }\n  em_hide .em_defaultlink a {\n    color: inherit;\n    text-decoration: none;\n  }\n  .em_g_img + div {\n    display: none;\n  }\n\n  .em_wrapper,\n  .em_hide {\n    background-color: #ffffff;\n  }\n}\n\n@media only screen and (max-width: 640px) {\n  .edm-gio-wrapper {\n    .em_img {\n      width: 100% !important;\n      height: auto !important;\n    }\n    .em_main_table {\n      width: 100% !important;\n    }\n    .em_wrapper {\n      width: 100% !important;\n    }\n    .em_wrapper1 {\n      width: 100% !important;\n      display: block !important;\n    }\n    .em_wrapper2 {\n      width: 60% !important;\n    }\n    .em_wrapper3 {\n      width: 40% !important;\n    }\n    .em_height {\n      height: auto !important;\n    }\n    .em_hide {\n      display: none !important;\n    }\n    .em_padding20 {\n      padding-top: 20px !important;\n    }\n    .em_padding {\n      padding-left: 10px !important;\n      padding-right: 10px !important;\n    }\n    .em_font22 {\n      font-size: 22px !important;\n      line-height: 28px !important;\n    }\n    .em_font {\n      font-size: 10px !important;\n      line-height: 14px !important;\n    }\n    u + .em_body .em_full_wrap {\n      width: 100% !important;\n      width: 100vw !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
